import React, { useState, useContext, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import signin from "../assets/img/others/signin.png";
import logo from "../assets/img/logo/bfc-logo-removebg-preview.png";
import { FaPenAlt } from "react-icons/fa";
import { UserContext } from "../context/User";
import { CartContext } from "../context/CartContext";

const Otp = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [errorOtp, setErrorOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(30);

  const location = useLocation();
  const navigate = useNavigate();
  const { Userotp } = useContext(UserContext);
  const { fetchExistingCart } = useContext(CartContext);

  // ✅ Grab data passed from signup or signin
  const { name, email, mobile } = location.state || {};

  // Redirect if no mobile (means someone came directly here)
  useEffect(() => {
    if (!mobile) {
      navigate("/signin");
    }
  }, [mobile, navigate]);

  // ⏳ Handle resend timer
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [resendTimer]);

  // 🔢 Handle OTP input
  const inputs = document.querySelectorAll("input[type='text']");

inputs.forEach((input, index) => {
  input.addEventListener("keydown", (e) => {
    if (e.key === "Backspace" && !input.value && index > 0) {
      inputs[index - 1].focus();
    }
  });

  input.addEventListener("input", () => {
    if (input.value && index < inputs.length - 1) {
      inputs[index + 1].focus();
    }
  });
});

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  // ✅ Verify OTP
  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    const otpCode = otp.join("");

    if (otpCode.length !== 6) {
      setErrorOtp("Please enter a valid 6-digit OTP");
      return;
    }

    setIsLoading(true);
    setErrorOtp("");

    try {
      const response = await Userotp({ email, mobile, otp: otpCode });

      if (response.data.access_token) {
        console.log("from otp existing cart ",response.data.access_token);
        
        // await fetchExistingCart(response.data.access_token);
        navigate("/");
      } else {
        setErrorOtp(response?.data?.message || "Invalid OTP. Please try again.");
      }
    } catch (error) {
      setErrorOtp(
        error.response?.data?.message || "Error verifying OTP. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  // 🔄 Resend OTP
  const handleResendOtp = async (e) => {
    e.preventDefault();
    if (resendTimer > 0) return;

    setResendLoading(true);
    setErrorOtp("");

    try {
      const response = await axios.post(
        "https://admin.bookstore.bfcpublications.com/api/resend_otp",
        name && email ? { name, email, mobile } : { mobile } // if from signup, send all
      );

      if (response.data.success) {
        setErrorOtp("OTP resent successfully!");
        setOtp(["", "", "", "", "", ""]);
        setResendTimer(30);
      } else {
        setErrorOtp(response.data.message || "Failed to resend OTP.");
      }
    } catch (error) {
      setErrorOtp(
        error.response?.data?.message || "Error resending OTP. Try again."
      );
    } finally {
      setResendLoading(false);
    }
  };

  // Format masked mobile
  const formatMobile = (mobile) => {
    if (!mobile) return "+91 XXXXXXXX98";
    return `+91 ${mobile.slice(0, 2)}XXXXXX${mobile.slice(-2)}`;
  };

  return (
    <section className="login-bg pt-3">
      <div className="container">
        <div className="brand-logo">
          <a href="/">
            <img src={logo} alt="BFC Logo" className="img-fluid" />
          </a>
        </div>

        <div className="row align-items-stretch pt-5">
          <div className="col-md-6 d-md-block d-none">
            <img src={signin} alt="Signin Illustration" className="img-fluid" />
          </div>

          <div className="col-md-6 align-self-center">
            <div className="shadow p-3 rounded-lg bg-white">
              <h4 className="pb-3 text_color font-bold text-2xl">Verify OTP</h4>
              <form onSubmit={handleOtpSubmit}>
                <p className="login-first-step-para pb-2">
                  An OTP has been sent to
                  <span className="text_color">
                    {" "}
                    {formatMobile(mobile)}
                    <Link to="/signin" className="px-2 text_color">
                      <FaPenAlt />
                    </Link>
                  </span>
                </p>

                <div className="otp-input d-flex gap-2 justify-content-center">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      id={`otp-input-${index}`}
                      type="text"
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handleOtpChange(e, index)}
                      required
                      className="search-input text-center p-2 border rounded"
                      style={{ width: "40px" }}
                    />
                  ))}
                </div>

                {errorOtp && (
                  <span className="text-red-500 text-sm text-danger">
                    {errorOtp}
                  </span>
                )}

                <p className="login-first-step-para pt-2">
                  Didn't Receive OTP?{" "}
                  <span className="text_color">
                    <a
                      href="#"
                      className="text_color font-bold"
                      onClick={handleResendOtp}
                      style={{
                        pointerEvents:
                          resendTimer > 0 || resendLoading ? "none" : "auto",
                        opacity:
                          resendTimer > 0 || resendLoading ? 0.5 : 1,
                      }}
                    >
                      {resendLoading
                        ? "Resending..."
                        : resendTimer > 0
                        ? `Resend OTP in ${resendTimer}s`
                        : "Resend OTP"}
                    </a>
                  </span>
                </p>

                <div className="form-group mt-4">
                  <button
                    type="submit"
                    className={`fw-bold border-0 text-white login_btn rounded-pill bg_color w-100 py-2 ${
                      isLoading ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                    disabled={isLoading}
                  >
                    {isLoading ? "Verifying..." : "Verify"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Otp;
